// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3_mu_","list":"BalanceDue_list__bStjM","listRow":"BalanceDue_listRow__2Gdha","total":"BalanceDue_total__2PloI"};